/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ tool: NonNullable<unknown> }} Audit_Details_Spoken_Approved_DescInputs */



/**
* | output |
* | --- |
* | "Spoken approval: {tool}" |
*
* @param {Audit_Details_Spoken_Approved_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const audit_details_spoken_approved_desc = /** @type {((inputs: Audit_Details_Spoken_Approved_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Details_Spoken_Approved_DescInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Mündliche Freigabe: ${i?.tool}`)
	return /** @type {LocalizedString} */ (`Spoken approval: ${i?.tool}`)
});